<template>
  <div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
    <Navigator/>
    <SliderBanner  :slider="slider"/>
    <FuncShow :funInfo="funInfo"/>
    <Footer/>
    <ContactFloat/>
  </div>
</template>

<script>
import Navigator from '../widgets/navigator'
import Footer from '../widgets/footer'
import SliderBanner from '../widgets/SliderBanner'
import FuncShow from '../widgets/func-show'
import ContactFloat from '../widgets/contact-float.vue'

export default {
  components: {
    Navigator,
    FuncShow,
    ContactFloat,
    SliderBanner,
    Footer
  },
  data() {
    return {
      slider: {
        image: require('@/assets/images/index/order/phone.png'),
        title: 'CPS点餐',
        desc: "先选择餐厅，然后在线点餐，等待取餐码，到点取餐即可，享受各种优惠福利"
      },
      funInfo: {
        title: 'CPS点餐',
        list: [
          {
            title: '肯德基',
            img: require('@/assets/images/index/order/img1.png'),
            text: '用智莺系统，手机点肯德基5折起，可自助点餐和外卖，不仅轻松解决高峰排队,顾客手机即可下单,订单不出错,无需客服协助,有效节约了人力成本!'
          },
          {
            title: '麦当劳',
            img:  require('@/assets/images/index/order/img2.png'),
            text: '用智莺系统，手机点麦当劳更优惠，不仅轻松解决高峰排队,顾客手机即可下单,订单不出错,无需客服协助,有效节约了人力成本!'
          },
          {
            title: '限时促销',
            img:  require('@/assets/images/index/order/img3.png'),
            text: '基于商品的促销工具，包括打折、赚佣金2种优惠形式，活动开始后自动展示促销价，结束恢复原价。是推新品和爆品的有力工具，可以快速有效地提升商品的订单转化率。'
          }
        ]
      }
    }
  }
}
</script>

<style scoped lang="scss">
</style>
